var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0026 2.33301C7.55964 2.33301 2.33594 7.55671 2.33594 13.9997C2.33594 16.1195 2.90193 18.1078 3.89031 19.8213L2.39774 25.1341C2.30035 25.4808 2.61885 25.7993 2.96552 25.7019L8.27837 24.2093C9.99188 25.1977 11.9802 25.7637 14.0999 25.7637C20.5429 25.7637 25.7666 20.54 25.7666 14.097C25.7666 7.65403 20.5429 2.43033 14.0999 2.43033C14.0675 2.43033 14.0351 2.43069 14.0026 2.4314V2.33301ZM9.83809 8.09341C9.63834 8.09341 9.31392 8.16826 9.03941 8.46774C8.7649 8.76722 7.99219 9.48998 7.99219 10.9605C7.99219 12.4311 9.0643 13.8517 9.21406 14.0515C9.36382 14.2512 11.2989 17.3806 14.3489 18.5771C16.8828 19.5712 17.3987 19.3735 17.9477 19.3236C18.4967 19.2737 19.7185 18.6008 19.9682 17.9029C20.218 17.2051 20.218 16.6072 20.1431 16.4824C20.0682 16.3576 19.8685 16.2827 19.5689 16.1329C19.2694 15.9831 17.7986 15.2603 17.5239 15.1604C17.2493 15.0605 17.0496 15.0106 16.8499 15.3101C16.6502 15.6096 16.0776 16.2827 15.9028 16.4824C15.7281 16.6822 15.5533 16.7071 15.2537 16.5573C14.9542 16.4075 13.9908 16.0916 12.848 15.0731C11.9589 14.2807 11.3585 13.302 11.1837 13.0025C11.009 12.703 11.1651 12.5408 11.3151 12.3915C11.4499 12.2573 11.6146 12.0419 11.7644 11.8671C11.9142 11.6923 11.9641 11.5675 12.064 11.3678C12.1639 11.1681 12.114 10.9933 12.0391 10.8435C11.9642 10.6937 11.3825 9.21568 11.1329 8.62617C10.8905 8.05243 10.6445 8.12971 10.4611 8.12053C10.2871 8.11185 10.0874 8.09341 9.83809 8.09341Z",
    fill: "url(#paint0_linear_whatsapp)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_whatsapp",
    x1: 14.0013,
    y1: 2.33301,
    x2: 14.0013,
    y2: 25.7637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.33c367fd5e7862975cb0c4e6ea92174b.svg";
export { ForwardRef as ReactComponent };